import React, { useState } from "react";
import {
  Button,
  Container,
  H2,
  H3,
  Line,
  Section,
} from "../../Styles/Global.Styled";
import { css } from "styled-components";
import ArrowIcon from "../../Icons/ArrowIcon";

const priceSectionStyle = css`
  gap: 2vh;
  padding: 2vh;
  border-radius: 12px;
  box-shadow: 0 0 2px 2px ${({ theme }) => theme.main};
`;
const sectionHeader = css`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  color: ${({ theme }) => theme.main};
  font-size: 2.2vh;
`;
const mbFontSize = css`
  font-size: 2vh;
`;
const labelsCntStyle = css`
  flex-direction: column;
  gap: 1vh;
`;
const h4Style = css`
  font-size: 1.3vh;
  display: flex;
  justify-content: space-between;
  gap: 5vh;
`;
const h3Style = css`
  font-size: 1.6vh;
  display: flex;
  justify-content: space-between;
`;
const valueCntStyle = css`
  align-self: flex-end;
  justify-self: flex-end;
`;
const lineStyle = css`
  border: 1px solid lightgray;
`;
const bttnStyle = css`
  font-size: 1.5vh;
  background-color: ${({ theme }) => theme.main};
  color: white;
  padding: 0.75vh;
  border-radius: 25px;
  margin-top: 1vh;
`;
const toggleBttn = (hide) => css`
  display: ${hide ? "flex" : "none"};
`;
const hideDisplay = css`
  display: none;
`;
const widthStyle = css`
  width: 100%;
`;

const OrderInvoice = ({
  handleAction,
  toggle = false,
  orderAmount,
  disabled,
}) => {
  const [isPricingOpen, setPricingOpen] = useState(!toggle);
  return (
    <Section $baseStyle={priceSectionStyle} $mStyle={widthStyle}>
      <H2 $baseStyle={sectionHeader} $mStyle={mbFontSize}>
        Order Summary
        <Button
          $baseStyle={hideDisplay}
          $mStyle={toggleBttn(toggle)}
          onClick={() => setPricingOpen(!isPricingOpen)}
        >
          <ArrowIcon direction={isPricingOpen && "up"} />
        </Button>
      </H2>
      <Container
        $baseStyle={labelsCntStyle}
        $mStyle={!isPricingOpen && hideDisplay}
      >
        <H3 $baseStyle={h4Style}>
          <Container>Sub-total</Container>
          <Container $baseStyle={valueCntStyle}>{orderAmount.toFixed(2)}</Container>
        </H3>
        <H3 $baseStyle={h4Style}>
          <Container>Estimated delivery & handling </Container>
          <Container>Free</Container>
        </H3>
        <Line $baseStyle={lineStyle} />
        <H3 $baseStyle={h3Style}>
          Total
          <Container $baseStyle={valueCntStyle}>£{orderAmount.toFixed(2)}</Container>
        </H3>
      </Container>
      {!disabled && (
        <Button
          $baseStyle={bttnStyle}
          $mStyle={hideDisplay}
          onClick={() => handleAction()}
        >
          Checkout
        </Button>
      )}
    </Section>
  );
};

export default OrderInvoice;
